import React from 'react';
import styled from 'styled-components';

export default props => <Container 
                            flex={props.flex ? 1 : 0} 
                            wrap={props.wrap ? 1 : 0} 
                            direction={props.direction} 
                            justify={props.justify} 
                            align={props.align} 
                            small={props.small} 
                            smaller={props.smaller} 
                            style={props.style} 
                            className={['container', props.className || ''].join(' ')}
                            id={props.id} 
                        >{props.children}</Container>

const Container = styled.div`
    width:100%;
    max-width:1260px;
    margin: 0 auto;
    position:relative;
    @media (max-width: 1300px) {
        padding: 0 20px;
    }

    ${props => props.flex ? `display: flex;` : ``}
    ${props => props.wrap ? `flex-wrap: wrap;` : ``}
    ${props => props.direction ? `flex-direction: ${props.direction};` : ``}
    ${props => props.justify ? `justify-content: ${props.justify};` : ``}
    ${props => props.align ? `align-items: ${props.align};` : ``}

    ${props => props.medium ? `
        max-width: 1024px;
        @media (max-width: 1064px) {
            padding: 0 20px;
        }
    ` : ``}


    ${props => props.small ? `
        max-width: 960px;
        @media (max-width: 1000px) {
            padding: 0 20px;
        }
    ` : ``}
    
    ${props => props.smaller ? `
        max-width: 780px;
        @media (max-width: 820px) {
            padding: 0 20px;
        }
    ` : ``}
    
`


// WEBPACK FOOTER //
// ./src/partials/Container.js